import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, Container } from "reactstrap";
import EnergyImg from '../../assets/images/1 10.svg';
import EconomiesImg from '../../assets/images/2 993686.svg';
import HealthSectorImg from '../../assets/images/3 7.svg';
import EnvironmentSectorImg from '../../assets/images/4 373122.svg';
import { useLocation, useNavigate } from "react-router-dom";
import Grid from '@mui/material/Grid';
import VisitorLogo from '../../assets/images/KVP Logo V3.png_1733200369161.svg';
import VisitorKacstLogo from '../../assets/images/Powered by KACST1.png (1)_1733200369161 (1).svg';
import { toast } from "react-toastify";
import { getVisitorSectors } from "../../api/casp/visitor";
import { TechnologySector } from "../../constants/Status";
import VisitorSmallLogo from '../../assets/images/MicrosoftTeams-image (116).png';
import VisitorSmallKacstLogo from '../../assets/images/visitor-small.svg'
import { getUrl } from "../../helpers/file_helper";


const VisitorPage = () => {
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(false);
    const [isLogoMobile, setIsLogoMobile] = useState(false);
    const [isLoading, setIsLoading] = useState()
    const [sectorData, setSectorData] = useState()
    const [projectLogo, setProjectLogo] = useState()

    useEffect(() => {
        fetchSectorCount()
    }, [])

    const fetchSectorCount = async () => {
        try {
            setIsLoading(true);
            const response = await getVisitorSectors()

            if (response.statusCode === 200) {
                setSectorData(response?.data?.data)
                const result = []
                response?.data?.data?.projectsLogo?.forEach((item, index) => {
                    const project = randomImage(response?.data?.data?.projectsLogo)
                    if (result?.length < 12 && ['jpg', 'JPEG', 'jpeg', 'png', 'gif'].includes(project.logo?.name?.split('.').pop().toString()) && !result?.find((el) => el?.logo?.name === project?.logo?.name)) {
                        result.push(project)
                    }
                })
                setProjectLogo(result)
                setIsLoading(false);
            } else {
                toast.error(response.data.error);
                setIsLoading(false);
            }
        } catch (err) {
            setIsLoading(false);
            toast.error(err.message);
        }
    }
    const handleLogoCardClick = (project) => {
        const label = project?.sector?.replaceAll(/\s|and/gi, "");
        navigate(`/${label}/project/${project?.id}`);
    }
    const handleCardClick = (label) => {
        navigate(`/${label?.replaceAll(/\s|and/gi, "")}`); // Redirect to the details page
    };

    const fetchSector = (label) => {
        return sectorData?.projectTechnologySector?.find((item) => item?.sector === label)?._count ?? 0
    }
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 767);
        };
        handleResize();

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const handleLogoResize = () => {
            setIsLogoMobile(window.innerWidth <= 767);
        };
        handleLogoResize();

        window.addEventListener("resize", handleLogoResize);

        return () => window.removeEventListener("resize", handleLogoResize);
    }, []);

    const randomImage = (projectData) => {
        return projectData[Math.floor(Math.random() * projectData?.length)]
    }

    const handleLoginRedirect = () => {
        window.open('https://kvp32.com/login', "_blank")
    }

    return (
        <React.Fragment>
            <header id="page-topbar page_header">
                <div className="layout-width">
                    <div className="navbar-header flex-wrap ps-2">
                        {isMobile ? (
                            <div>
                                <img alt="visitor-small-logo" style={{ height: '60px', width: '100%' }} src={VisitorSmallLogo} />
                            </div>
                        ) :
                            (
                                <div>
                                    <img alt='visitor-logo' src={VisitorLogo} />
                                </div>
                            )}
                        {isLogoMobile ? (
                            <div className="d-flex justify-content-end">
                                <img alt='visitor-small-logo' style={{ height: '50px', width: '100%' }} src={VisitorSmallKacstLogo} />
                            </div>
                        ) :
                            (
                                <div className="d-flex justify-content-end">
                                    <img alt='visitor-logo' src={VisitorKacstLogo} />
                                </div>
                            )}
                    </div>
                </div>
            </header>
            <div className="page_content_header position-relative">
                {sectorData?.projectTechnologySector?.length && sectorData?.projectTechnologySector?.length > 0 && (
                    <Container fluid>
                        <div className="visitor_heading">
                            <div className="d-flex align-items-center justify-content-between">
                            <div><h4>KACST Venture Program (KVP)</h4></div>
                                <div><Button className='btn w-100 main-login-btn btn btn-secondary' onClick={handleLoginRedirect}>Login</Button></div>
                            </div>
                            <p className="mb-0 mt-1">The KACST Venture Program (KVP), under the umbrella of the King Abdulaziz City for Science and Technology (KACST), is dedicated to supporting research-based startups and innovative ventures aligned with Saudi Arabia's national Research, Development, and Innovation (RDI) priorities.</p>
                        </div>
                        <div className="visitor_heading mt-2">
                            <h4>Sector Segment</h4>
                            <Grid container spacing={2}>
                                {/* <div className="d-flex w-100 justify-content-between flex-wrap gap-2 sector_segment_wrap"> */}
                                <Grid item xs={12} sm={12} md={6} lg={3}>
                                    <div className="sector_segment_card" style={fetchSector(TechnologySector.ENERGY_INDUSTRY_SECTOR) > 0 ? { cursor: 'pointer' } : { cursor: 'not-allowed' }} onClick={() => handleCardClick(TechnologySector.ENERGY_INDUSTRY_SECTOR)}>
                                        <Card className='mb-0'>
                                            <CardBody>
                                                <div className="d-flex gap-2 justify-content-between w-100">
                                                    <div className="d-flex gap-2">
                                                        <div><img alt="energy" src={EnergyImg} /></div>
                                                        <div className="sector_segment_card_holder mt-1">
                                                            <div className="position-relative d-flex justify-content-between">
                                                                <div>
                                                                    <p className="mb-0" style={{ color: '#2B2F3E', fontWeight: '700', fontSize: '20px' }}>{fetchSector(TechnologySector.ENERGY_INDUSTRY_SECTOR)}</p>
                                                                </div>
                                                            </div>
                                                            <p className="mb-0 mt-2" style={{ color: '#6B7083', fontWeight: '400', fontSize: '16px' }}>{TechnologySector.ENERGY_INDUSTRY_SECTOR}</p>
                                                        </div>
                                                    </div>
                                                    <div><i className="bx bx-chevron-right"></i></div>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={3}>
                                    <div className="sector_segment_card" style={fetchSector(TechnologySector.FUTURE_ECONOMY_SECTOR) > 0 ? { cursor: 'pointer' } : { cursor: 'not-allowed' }} onClick={() => handleCardClick(TechnologySector.FUTURE_ECONOMY_SECTOR)}>
                                        <Card className='mb-0'>
                                            <CardBody>
                                                <div className="d-flex gap-2 justify-content-between w-100">
                                                    <div className="d-flex gap-2">
                                                        <div><img alt="energy" src={EconomiesImg} /></div>
                                                        <div className="sector_segment_card_holder mt-1">
                                                            <div className="position-relative d-flex justify-content-between">
                                                                <div>
                                                                    <p className="mb-0" style={{ color: '#2B2F3E', fontWeight: '700', fontSize: '20px' }}>{fetchSector(TechnologySector.FUTURE_ECONOMY_SECTOR)}</p>
                                                                </div>
                                                            </div>
                                                            <p className="mb-0 mt-2" style={{ color: '#6B7083', fontWeight: '400', fontSize: '16px' }}>{TechnologySector.FUTURE_ECONOMY_SECTOR}</p>
                                                        </div>
                                                    </div>
                                                    <div><i className="bx bx-chevron-right"></i></div>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={3}>
                                    <div className="sector_segment_card" style={fetchSector(TechnologySector.HELATH_SECTOR) > 0 ? { cursor: 'pointer' } : { cursor: 'not-allowed' }} onClick={() => handleCardClick(TechnologySector.HELATH_SECTOR)}>
                                        <Card className='mb-0'>
                                            <CardBody>
                                                <div className="d-flex gap-2 justify-content-between w-100">
                                                    <div className="d-flex gap-2">
                                                        <div><img alt="energy" src={HealthSectorImg} /></div>
                                                        <div className="sector_segment_card_holder mt-1">
                                                            <div className="position-relative d-flex justify-content-between">
                                                                <div>
                                                                    <p className="mb-0" style={{ color: '#2B2F3E', fontWeight: '700', fontSize: '20px' }}>{fetchSector(TechnologySector.HELATH_SECTOR)}</p>
                                                                </div>
                                                            </div>
                                                            <p className="mb-0 mt-2" style={{ color: '#6B7083', fontWeight: '400', fontSize: '16px' }}>{TechnologySector.HELATH_SECTOR}</p>
                                                        </div>
                                                    </div>
                                                    <div><i className="bx bx-chevron-right"></i></div>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={3}>
                                    <div className="sector_segment_card" style={fetchSector(TechnologySector.SUSTAINABILIY_ENVIRONMENT_SECTOR) > 0 ? { cursor: 'pointer' } : { cursor: 'not-allowed' }} onClick={() => handleCardClick(TechnologySector.SUSTAINABILIY_ENVIRONMENT_SECTOR)}>
                                        <Card className='mb-0'>
                                            <CardBody>
                                                <div className="d-flex gap-2 justify-content-between w-100">
                                                    <div className="d-flex gap-2">
                                                        <div><img alt="energy" src={EnvironmentSectorImg} /></div>
                                                        <div className="sector_segment_card_holder mt-1">
                                                            <div className="position-relative d-flex justify-content-between">
                                                                <div>
                                                                    <p className="mb-0" style={{ color: '#2B2F3E', fontWeight: '700', fontSize: '20px' }}>{fetchSector(TechnologySector.SUSTAINABILIY_ENVIRONMENT_SECTOR)}</p>
                                                                </div>
                                                            </div>
                                                            <p className="mb-0 mt-2" style={{ color: '#6B7083', fontWeight: '400', fontSize: '16px' }}>{TechnologySector.SUSTAINABILIY_ENVIRONMENT_SECTOR}</p>
                                                        </div>
                                                    </div>
                                                    <div><i className="bx bx-chevron-right"></i></div>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                        <div className="d-flex w-100 flex-wrap justify-content-between visitor_card_wrap mt-3">
                            <div className="visitor_card visitor_heading">
                                <Card>
                                    <CardBody>
                                        <h4>Saudi Arabia's National R&D Priorities</h4>
                                        <div>
                                            <ul>
                                                <li>
                                                    <span className="mb-0">Health and Wellness:</span>
                                                    <p className="mb-2"> Enhancing healthcare services and promoting overall well-being</p>
                                                </li>
                                                <li>
                                                    <span className="mb-0">Sustainable Environment and Basic Needs:</span>
                                                    <p className="mb-2">Ensuring environmental sustainability and addressing essential societal needs.</p>
                                                </li>
                                                <li>
                                                    <span>Energy and Industrial Leadership:</span>
                                                    <p className="mb-2">Advancing energy solutions and establishing leadership in industrial sectors</p>
                                                </li>
                                                <li>
                                                    <span>Economies of the Future:</span>
                                                    <p className="mb-2">Fostering innovation to build future-oriented economic sectors.</p>
                                                </li>
                                            </ul>
                                            <p className="mb-0">Key Achievements of the First KVP Cohort</p>
                                        </div>
                                    </CardBody>
                                </Card>
                            </div>
                            <div className="visitor_card visitor_heading">
                                <Card>
                                    <CardBody>
                                        <h4>Startups Graduation</h4>
                                        <div>
                                            <ul>
                                                <li>
                                                    <p className="mb-2">A total of 46 startups successfully graduated, contributing significantly to the entrepreneurial ecosystem and focusing on R&D priorities that drive national progress</p>
                                                </li>
                                                <li>
                                                    <span className="mb-3">Licensing Agreements:</span>
                                                    <p className="mb-2">2 agreements signed with private sector entities, fostering impactful collaborations between research and industry</p>
                                                    <p className="mb-0">5 agreements licensed to startups, enabling the commercialization of innovative, research-driven technologies.</p>
                                                </li>
                                            </ul>
                                            <p className="mb-0">These accomplishments highlight KVP’s commitment to advancing innovation and strengthening Saudi Arabia's position as a global leader in research and technology</p>
                                        </div>
                                    </CardBody>
                                </Card>
                            </div>
                        </div>
                        <div className="d-flex w-100 flex-wrap justify-content-between industry_card_wrap mt-1">
                            {sectorData?.projectsLogo?.length > 0 && projectLogo?.length > 0 && (
                                <><Grid container spacing={2}>
                                    {projectLogo?.map((project, index) => (
                                        <Grid item xs={12} sm={12} md={2} lg={2} key={index}>
                                            <div onClick={() => handleLogoCardClick(project)}>
                                                <Card>
                                                    <CardBody>
                                                    <div class="logo-wrapper">
                                                        <img src={getUrl(project?.logo?.storageLink)} alt="visitor-small-logo" className="logo" />
                                                    </div>
                                                    </CardBody>
                                                </Card>
                                            </div>
                                        </Grid>
                                    ))}

                                    {/* <Grid item xs={12} sm={12} md={2} lg={2}>
                                        <div>
                                            <Card>
                                                <CardBody>
                                                    <img src={GreenEnergyImg} width='100%' />
                                                </CardBody>
                                            </Card>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={2} lg={2}>
                                        <div>
                                            <Card>
                                                <CardBody>
                                                    <img src={HPCEnergyImg} width='100%' />
                                                </CardBody>
                                            </Card>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={2} lg={2}>
                                        <div>
                                            <Card>
                                                <CardBody>
                                                    <img src={SolarEnergyImg} width='100%' />
                                                </CardBody>
                                            </Card>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={2} lg={2}>
                                        <div>
                                            <Card>
                                                <CardBody>
                                                    <img src={HolisticEnergyImg} width='100%' />
                                                </CardBody>
                                            </Card>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={2} lg={2}>
                                        <div>
                                            <Card>
                                                <CardBody>
                                                    <img src={HolisticEnergyImg} width='100%' />
                                                </CardBody>
                                            </Card>
                                        </div>
                                    </Grid> */}
                                </Grid>
                                    {/* <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12} md={2} lg={2}>
                                            <div>
                                                <Card>
                                                    <CardBody>
                                                        <img src={EnergyIndustryImg} width='100%' />
                                                    </CardBody>
                                                </Card>
                                            </div>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={2} lg={2}>
                                            <div>
                                                <Card>
                                                    <CardBody>
                                                        <img src={GreenEnergyImg} width='100%' />
                                                    </CardBody>
                                                </Card>
                                            </div>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={2} lg={2}>
                                            <div>
                                                <Card>
                                                    <CardBody>
                                                        <img src={HPCEnergyImg} width='100%' />
                                                    </CardBody>
                                                </Card>
                                            </div>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={2} lg={2}>
                                            <div>
                                                <Card>
                                                    <CardBody>
                                                        <img src={SolarEnergyImg} width='100%' />
                                                    </CardBody>
                                                </Card>
                                            </div>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={2} lg={2}>
                                            <div>
                                                <Card>
                                                    <CardBody>
                                                        <img src={HolisticEnergyImg} width='100%' />
                                                    </CardBody>
                                                </Card>
                                            </div>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={2} lg={2}>
                                            <div>
                                                <Card>
                                                    <CardBody>
                                                        <img src={HolisticEnergyImg} width='100%' />
                                                    </CardBody>
                                                </Card>
                                            </div>
                                        </Grid>
                                    </Grid> */}
                                </>
                            )}

                        </div>

                        {/* </div> */}
                    </Container>
                )}
            </div>
        </React.Fragment>
    )
}
export default VisitorPage;